import { render } from "./InformacionContratos.vue?vue&type=template&id=0f8c4e67&scoped=true"
import script from "./InformacionContratos.vue?vue&type=script&lang=js"
export * from "./InformacionContratos.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./InformacionContratos.vue?vue&type=style&index=1&id=0f8c4e67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8c4e67"]])

export default __exports__